import "semantic-ui-css/semantic.min.css";
import "./static/fonts/typography.css";
